import { shape, func } from 'prop-types';

const RouterPropTypes = shape({
  location: shape({}),
  navigate: func,
  match: shape({ params: shape({}) }),
});

// eslint-disable-next-line import/prefer-default-export
export { RouterPropTypes };
